import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Container, Row, Col, Navbar, Spinner } from 'react-bootstrap';
import { FiList, FiSearch } from 'react-icons/fi';
import { FaFilter, FaPlus, FaStar } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';

import { limparProspectoFiltro } from '~/Store/Prospecto/actions';
import ProspectoBuscaFormulario from './ProspectoBuscaFormulario';
import Outsider from '~/Components/Outsider';
import { ChartBarHorizontal, UserPlus } from 'phosphor-react';
import AuthStorage from '~/Utils/AuthStorage';

class ProspectoBusca extends Component {
  state = {
    isSearchActive: false,
  };

  toggleSearch = () =>
    this.setState({ isSearchActive: !this.state.isSearchActive });

  closeSearch = () => this.setState({ isSearchActive: false });

  handleSubmit = values => {
    this.closeSearch();
    this.props.onSubmit(values);
  };

  render() {
    const { isSearchActive } = this.state;

    const {
      filterIsDirty,
      filter,
      isLoadingOptions,
      isLoading,
      empreendimentos,
      limparProspectoFiltro,
      readonly,
    } = this.props;

    return (
      <Outsider onClickOut={() => isSearchActive && this.closeSearch()}>
        <Navbar className="bg-white mb-3" expand="lg">
          <>
            <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
              <Button
                className="btn mr-2"
                variant="outline-secondary"
                title="Visão Kanban"
                size="sm"
                as={Link}
                to="/prospectos"
              >
                <ChartBarHorizontal />
              </Button>

              <Button
                className="active btn btn-outline-secondary mr-2"
                title="Visão Lista"
                size="sm"
              >
                <FiList />
              </Button>

              <Link
                className={`btn btn-sm mr-2 ${
                  !!(isLoading || isLoadingOptions) ? 'disabled' : ''
                }`}
                to={isLoading ? '#' : { search: '?novo=true' }}
                style={{
                  minHeight: '29px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  pointerEvents:
                    isLoading || isLoadingOptions ? 'none' : 'auto',
                  opacity: isLoading || isLoadingOptions ? 0.6 : 1,
                  background: '#419AEF',
                  borderColor: '#419AEF',
                  color: '#fff',
                  fontFamily: 'Open Sans, Arial, sans-serif',
                }}
                title="Adicionar Prospecto"
              >
                {isLoading || isLoadingOptions ? (
                  <Spinner role="status" size="sm" animation="border"></Spinner>
                ) : (
                  <>
                    <UserPlus />
                    <span className="ml-2 d-none d-md-inline">Adicionar</span>
                  </>
                )}
              </Link>

              <Button
                type="button"
                variant={'outline-primary'}
                size="sm"
                onClick={this.toggleSearch}
                className="mr-2 active"
                style={{
                  background: '#419AEF',
                  borderColor: '#419AEF',
                  fontFamily: 'Open Sans, Arial, sans-serif',
                }}
              >
                <FaFilter
                  size={15}
                  color="#419AEF"
                  style={{
                    stroke: '#fff',
                    strokeWidth: 32,
                    verticalAlign: 'middle',
                  }}
                />{' '}
                <span className="d-none d-md-inline">Filtros</span>
              </Button>
            </div>
          </>
        </Navbar>
        {isSearchActive && (
          <div className="bg-white p-2">
            <Container>
              <Row>
                <Col>
                  <ProspectoBuscaFormulario
                    onSubmit={this.handleSubmit}
                    onReset={limparProspectoFiltro}
                    filter={filter}
                    empreendimentos={empreendimentos}
                    isLoading={isLoading}
                    isLoadingOptions={isLoadingOptions}
                    filterIsDirty={filterIsDirty}
                  />
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </Outsider>
    );
  }
}

const mapStateToProps = state => ({
  empreendimentos: state.empreendimentos,
  isLoadingOptions: state.prospecto.isLoadingOptions,
  filter: state.prospecto.filter,
  isSearchActive: state.prospecto.isSearchActive,
  isLoading: state.prospecto.isLoading,
  filterIsDirty: Object.keys(state.prospecto.filter)
    .filter(item => item !== 'tipo_filtro')
    .reduce((prev, curr) => {
      return !!state.prospecto.filter[curr] || prev;
    }, false),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      limparProspectoFiltro,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProspectoBusca);
